import { createAction, props } from '@ngrx/store';
import { ClientDto, CreateClientDto, UpdateClientDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';

// Read list
// readClients(query) -> server-paginated page (table)
// readClients()      -> full list (dashboard, select, breadcrumb, form)
export const readClients = createAction('@app/client/read', (params?: string | number | Record<string, string | number>, query?: PaginatedListQuery) => ({ params, query }));
export const readClientsSuccess = createAction('@app/client/read/success', props<{ data: ClientDto[]; total: number }>());
export const readClientsFailure = createAction('@app/client/read/failure', props<{ error: any }>());

// Read single (detail) — resolves from the loaded list by id, falling back to a
// server fetch (readOne) so a reload/deep-link always has the full, fresh detail.
export const readClient = createAction('@app/client/read-one', props<{ clientId: number }>());
export const readClientSuccess = createAction('@app/client/read-one/success', props<{ client: ClientDto }>());
export const readClientFailure = createAction('@app/client/read-one/failure', props<{ error: any }>());

// Create
export const createClient = createAction('@app/client/create', props<{ dto: CreateClientDto }>());
export const createClientSuccess = createAction('@app/client/create/success', props<{ client: ClientDto }>());
export const createClientFailure = createAction('@app/client/create/failure', props<{ error: any }>());

// Update
export const updateClient = createAction('@app/client/update', props<{ clientId: number; dto: UpdateClientDto }>());
export const updateClientSuccess = createAction('@app/client/update/success', props<{ client: Partial<ClientDto> }>());
export const updateClientFailure = createAction('@app/client/update/failure', props<{ error: any }>());

// Delete
export const deleteClient = createAction('@app/client/delete', props<{ clientId: number }>());
export const deleteClientSuccess = createAction('@app/client/delete/success', props<{ client: ClientDto }>());
export const deleteClientFailure = createAction('@app/client/delete/failure', props<{ error: any }>());

// Restore
export const restoreClient = createAction('@app/client/restore', props<{ clientId: number }>());
export const restoreClientSuccess = createAction('@app/client/restore/success', props<{ client: ClientDto }>());
export const restoreClientFailure = createAction('@app/client/restore/failure', props<{ error: any }>());
